"use strict";
export const DEFAULT_META_DESCRIPTION = "Topaz Dex \u2014 the ve(3,3) decentralized exchange on BNB Chain. Swap, provide liquidity, lock TOPAZ, and vote.";
export const DEFAULT_OG_IMAGE = "https://app.topazdex.com/preview.jpg";
export const APP_URL = "https://app.topazdex.com";
